<footer class="footer">

  <!-- ── Grid principal ── -->
  <div class="footer-main">

    <!-- Coluna: Brand -->
    <div class="footer-brand anim">
      <img class="footer-logo" src="./assets/images/vertical-logo-breakers.png" alt="Logo Breakers">
      <p class="footer-tagline">
        A jornada do jovem Henshi Shiranai, se inicia -- AGORA!
      </p>
      <div class="footer-social">
        <a class="social-link" href="https://www.instagram.com/aaronblaze_autor/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
          </svg>
        </a>
        <a class="social-link" href="https://www.facebook.com/aaronblaze.autor/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
          </svg>
        </a>
        <a class="social-link" href="https://www.tiktok.com/@aaronblaze_autor?_t=8epg5JQf1qn&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.86a8.17 8.17 0 0 0 4.78 1.52V6.93a4.85 4.85 0 0 1-1.01-.24z"/>
          </svg>
        </a>
      </div>
    </div>

    <!-- Coluna: Navegação -->
    <div class="footer-col anim anim--delay-1">
      <h4 class="footer-col-title">Navegação</h4>
      <ul class="footer-links">
        <li><a (click)="scrollTo('#apresentation', $event)" href="#apresentation">Início</a></li>
        <li><a (click)="scrollTo('#sinopse', $event)" href="#sinopse">Sinopse</a></li>
        <li><a (click)="scrollTo('#qrcode', $event)" href="#qrcode">QR Code</a></li>
        <li><a (click)="scrollTo('#preview', $event)" href="#preview">Preview</a></li>
        <li><a (click)="scrollTo('#depoimentos', $event)" href="#depoimentos">Depoimentos</a></li>
        <li><a (click)="scrollTo('#compra', $event)" href="#compra">Comprar</a></li>
      </ul>
    </div>

    <!-- Coluna: Adquira -->
    <div class="footer-col anim anim--delay-2">
      <h4 class="footer-col-title">Adquira</h4>
      <ul class="footer-links">
        <li>
          <a href="https://www.amazon.com.br/dp/B09NZ58ZQN" target="_blank" rel="noopener noreferrer" class="footer-market-link">
            Amazon
            <span class="market-badge">Kindle</span>
          </a>
        </li>
        <li>
          <a href="https://www.amazon.com.br/Breakers-Queda-das-Chamas-brindes/dp/6558991365/ref=tmm_pap_swatch_0" target="_blank" rel="noopener noreferrer" class="footer-market-link">
            Amazon
            <span class="market-badge">Físico</span>
          </a>
        </li>
        <li>
          <a href="https://produto.mercadolivre.com.br/MLB-2620820155-livro-breakers-a-queda-das-chamas-com-brindes-_JM" target="_blank" rel="noopener noreferrer" class="footer-market-link">
            Mercado Livre
            <span class="market-badge">Físico</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Coluna: Autor -->
    <div class="footer-col anim anim--delay-3">
      <h4 class="footer-col-title">O Autor</h4>
      <p class="footer-author-bio">
        Meu nome verdadeiro? É Lucas Santos, que tal nos conhecermos melhor? Bora conversar pelo Instagram. 
      </p>
      <a class="footer-author-cta" href="https://www.instagram.com/aaronblaze_autor/" target="_blank" rel="noopener noreferrer">
        Seguir Autor
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </a>
    </div>

  </div>

  <!-- ── Divisor ── -->
  <div class="footer-divider"></div>

  <!-- ── Barra inferior ── -->
  <div class="footer-bottom">
    <p class="footer-copyright">
      © 2024 Breakers — A Queda das Chamas. Todos os direitos reservados.
    </p>
    <button class="footer-back-top" (click)="scrollToTop($event)" aria-label="Voltar ao topo">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"/>
      </svg>
      Voltar ao topo
    </button>
  </div>

</footer>
